import type { SourceProvider }                           from './index'
import type { ConnectedSource, ConnectedRepo, FileNode } from '@/tools/exmarked/types'
import { fetchRepoTree, fetchFileContent,
         extractMarkdownFiles }                          from '@/tools/exmarked/lib/github'

export const githubProvider: SourceProvider = {
  async listFiles(source: ConnectedSource) {
    const repo = source as ConnectedRepo
    const { tree, truncated } = await fetchRepoTree(
      repo.owner,
      repo.name,
      repo.default_branch,
    )
    const files: FileNode[] = extractMarkdownFiles(tree)
    return { files, truncated }
  },

  async readFile(source: ConnectedSource, file: FileNode) {
    const repo = source as ConnectedRepo
    const { content } = await fetchFileContent(repo.owner, repo.name, file.id, file.path)
    return content
  },
}
